import styled from 'styled-components';
import { semanticColors } from '@/common/styles/colorTokens';
export const Label = styled.label`
  font-size: 0.875rem;
  font-weight: 500;
  color: ${semanticColors.text.primary};
  display: block;
  margin-bottom: 0.5rem;
`; 